module.exports = __webpack_public_path__ + "img/四川天府新区第一小学.510f1c30.jpg";